import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import CollectionDialog from "@/components/finance/CollectionDialog";
import SupplierPaymentDialog from "@/components/finance/SupplierPaymentDialog";

const TYPES = [
  ["musteri_cek", "Müşteri Çeki", "Alınan çek · tahsilat (çek) olarak cari bakiyesine ve portföye işlenir"],
  ["musteri_senet", "Müşteri Senedi", "Alınan senet · tahsilat (senet) olarak işlenir"],
  ["kendi_cek", "Kendi Çekimiz", "Verilen çek · Tek Cari ödeme akışı (çek)"],
  ["kendi_senet", "Kendi Senedimiz", "Verilen senet · Tek Cari ödeme akışı (senet)"],
];

export default function NewInstrumentDialog({ onClose, onDone }) {
  const [t, setT] = useState(null);
  const done = () => { onDone?.(); onClose(); };
  if (t?.startsWith("musteri")) return <CollectionDialog initialMethod={t === "musteri_cek" ? "cek" : "senet"} onClose={onClose} onDone={done} />;
  if (t?.startsWith("kendi")) return <SupplierPaymentDialog initialMethod={t === "kendi_cek" ? "cek" : "senet"} onClose={onClose} onDone={done} />;
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="new-instrument-dialog">
        <DialogHeader><DialogTitle>Yeni Evrak</DialogTitle></DialogHeader>
        <div className="grid gap-2">
          {TYPES.map(([k, label, hint]) => (
            <Button key={k} variant="outline" className="h-auto justify-start py-2 text-left" onClick={() => setT(k)} data-testid={`new-instrument-${k}`}>
              <div><div className="font-semibold">{label}</div><div className="text-[11px] font-normal text-slate-500 whitespace-normal">{hint}</div></div>
            </Button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
